interface PreferenceFeedbackProps {
  message: string | null;
}

export function PreferenceFeedback({ message }: PreferenceFeedbackProps) {
  if (!message) return null;

  return (
    <div className="bg-primary/5 mt-4 rounded-lg p-3 text-sm text-gray-700">
      <span className="text-primary font-medium">What this means:</span> {message}
    </div>
  );
}
